const typeSymbolsArray = [
  {
    type: "Bug",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/9/9c/Bug_icon_SwSh.png/96px-Bug_icon_SwSh.png",
    color: "#407D6CBF",
  },
  {
    type: "Dark",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/d/d5/Dark_icon_SwSh.png/96px-Dark_icon_SwSh.png",
    color: "#323A4ABB",
  },
  {
    type: "Dragon",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/7/70/Dragon_icon_SwSh.png/96px-Dragon_icon_SwSh.png",
    color: "#587B89BF",
  },
  {
    type: "Fairy",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/c/c6/Fairy_icon_SwSh.png/96px-Fairy_icon_SwSh.png",
    color: "#E0BBE4BF",
  },
  {
    type: "Fighting",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/3/3b/Fighting_icon_SwSh.png/96px-Fighting_icon_SwSh.png",
    color: "#FCC200BF",
  },
  {
    type: "Fire",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/a/ab/Fire_icon_SwSh.png/96px-Fire_icon_SwSh.png",
    color: "#FF0018BF",
  },
  {
    type: "Flying",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/b/b5/Flying_icon_SwSh.png/96px-Flying_icon_SwSh.png",
    color: "#01AABABF",
  },
  {
    type: "Ghost",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/0/01/Ghost_icon_SwSh.png/96px-Ghost_icon_SwSh.png",
    color: "#5E526BBF",
  },
  {
    type: "Grass",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/a/a8/Grass_icon_SwSh.png/96px-Grass_icon_SwSh.png",
    color: "#50B342BF",
  },
  {
    type: "Ground",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/2/27/Ground_icon_SwSh.png/96px-Ground_icon_SwSh.png",
    color: "#AE5714BF",
  },
  {
    type: "Ice",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/1/15/Ice_icon_SwSh.png/96px-Ice_icon_SwSh.png",
    color: "#61CCC2BF",
  },
  {
    type: "Normal",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/9/95/Normal_icon_SwSh.png/96px-Normal_icon_SwSh.png",
    color: "#DFDED4BF",
  },
  {
    type: "Poison",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/8/8d/Poison_icon_SwSh.png/96px-Poison_icon_SwSh.png",
    color: "#A50078BF",
  },
  {
    type: "Psychic",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/7/73/Psychic_icon_SwSh.png/96px-Psychic_icon_SwSh.png",
    color: "#765FC2BF",
  },
  {
    type: "Rock",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/1/11/Rock_icon_SwSh.png/96px-Rock_icon_SwSh.png",
    color: "#896A3DBF",
  },
  {
    type: "Steel",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/0/09/Steel_icon_SwSh.png/96px-Steel_icon_SwSh.png",
    color: "#96989ABF",
  },
  {
    type: "Water",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/8/80/Water_icon_SwSh.png/96px-Water_icon_SwSh.png",
    color: "#0000F9BF",
  },
  {
    type: "Electric",
    url:
      "https://archives.bulbagarden.net/media/upload/thumb/7/7b/Electric_icon_SwSh.png/96px-Electric_icon_SwSh.png",
    color: "#FFFF41BF",
  },
];

export default typeSymbolsArray;
